import Logo from '@avanta/shared/assets/avanta-logo.svg';
import { Stepper } from '@avanta/shared/components/Stepper';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { SupportButton } from 'components/SupportButton';
import { ROUTES } from 'constants/routes';
import { type StepDefinition } from '../../../hooks/useStepNavigation';
import { AppointmentsReservePayload } from '../../../types';

type TopNavProps = {
  steps: StepDefinition[];
  currentStepIndex: number;
  showScrollShadow: boolean;
  onMobileBack?: () => void;
};

export const TopNav = ({
  steps,
  currentStepIndex,
  showScrollShadow,
  onMobileBack,
}: TopNavProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { watch } = useFormContext();
  const flow = watch(AppointmentsReservePayload.flow);

  return (
    <div
      className={cn(
        'relative mb-8 am-lg:mb-14 z-100',
        showScrollShadow && 'mb-0 pb-4 shadow-box-lg am-lg:mb-8 am-lg:pb-auto am-lg:shadow-none'
      )}
    >
      <header className="h-12 mx-auto flex w-full max-w-7xl items-center justify-between px-4 am-3xl:h-16 am-3xl:px-15 am-lg:px-18">
        <Link to={ROUTES.HOME} className="flex items-center">
          <img src={Logo} alt="Avanta Mynd Logo" className="w-23 am-lg:w-28 h-auto" />
        </Link>
        <SupportButton />
      </header>
      <div className="am-lg:container px-4 am-lg:max-w-3xl mx-auto flex flex-col am-lg:gap-4.5 gap-2 items-center">
        <h1 className="mt-6 text-center am-lg:text-2xl text-lg font-medium leading-7 text-denim-800">
          {t(`AppointmentsReserve.${flow}.title`)}
        </h1>
        <Stepper
          steps={steps}
          currentStep={currentStepIndex}
          i18nKey="AppointmentsReserve.Steps"
          i18nNs="appointments"
          className="am-lg:w-122 w-79"
          onMobileBack={onMobileBack}
        />
      </div>
    </div>
  );
};
